import { Injectable } from '@angular/core';

import DomainEventProvider from '../../../../core/domain/events/domain_event_provider';
import { TranscriptionEvent } from './transcription_events';

@Injectable({ providedIn: 'root' })
export class TranscriptionEventProvider extends DomainEventProvider<TranscriptionEvent> {}
